import MaxQueueStorage from '../../helpers/maxQueueStorage';
var AlreadyRated = MaxQueueStorage('RATE-BOX-SECURITY-CENTRAL', 50);
export default AlreadyRated;